<script lang="ts">
    import { recordsIntoOutService } from "../services";
    import type { RegisterInOut } from "../Model/RegisterInOut";
    import RegisterModal from "./RegisterModal.svelte";
    /* Importar formatos de fecha */
    import { dateInputFormatter } from '../services/Functions';
    import FilterRegister from "./FilterRegister.svelte"

    let registers: RegisterInOut[];

    let offset = 0;
    let limit = 25;
    let searchFilter = {
        register : null,
        selectRegister : null,
        selectType : null,
        date : null
    };

    let endDate = null;
    let startDate = null;
    let date = new Date();

    let editRegister = null;

    $: loadInputDate();

    export async function loadRegisters(searchFilter = null): Promise<void> {
        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        registers = await recordsIntoOutService.findRegisters(opts);

        /* registers.sort((a,b) => {
            return a.inRegisterNumber < b.inRegisterNumber ? -1 : 1;
        }) */

        registers = registers;
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth() + 1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];

        searchFilter.selectRegister = 'both';
        searchFilter.date = selectedDates;

        loadRegisters(JSON.stringify(searchFilter));
    }

    function registerUpdate(register: RegisterInOut): void {
        console.log('in')
        loadInputDate();
        // let registerAct = registers.find(u => u.id == register.id)

        // if (registerAct) {
        //     registerAct = register
        //     registers = registers;
        //     // loadInputDate()
        // }else{
        //     registers = [...registers, register];
        //     // loadInputDate()
        // }
    }

</script>

<style>

</style>

<FilterRegister bind:searchFilterComponent={searchFilter} type='entrada' on:load={() => loadRegisters(JSON.stringify(searchFilter))}/>

{#if registers}
    <div class="row mt-3">
        <div class="col-12">
            {#if registers?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Entrada</th>
                            <th scope="col">Fecha Entrada</th>
                            <th scope="col">Salida</th>
                            <th scope='col'>Fecha Salida</th>
                            <th scope="col">Tipo</th>
                        </tr>
                </thead>
                <tbody>
                    {#each registers as register, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                {#if register.inRegisterNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.inRegisterNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.inDate}
                                    <!-- {register.inDate} -->
                                    <span class="pe-2">{dateInputFormatter(register.inDate)}</span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outRegisterNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.outRegisterNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outDate}
                                    <!-- {register.outDate} -->
                                    <span class="pe-2">{dateInputFormatter(register.outDate)}</span>
                                {/if}
                            </td>
                            <td>
                                {#if register.contentInfo}
                                    {register.contentInfo}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay registros para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
{/if}


<RegisterModal bind:register={editRegister}  on:registerUpdate={(e) => {registerUpdate(e.detail)}} on:registerSave={() => console.log('in')}/>

